{
  "links" : {
    "triggerLinksDescription" : "Trigger Links Enable om links Inner SMS berichten en Gmail te You om specifieke activities te Enable en trigger You op On Link When geklikt.",
    "enterName" : "Naam invoeren",
    "enterLinkURL" : "Linkinvoeren -URL",
    "save" : "Archive",
    "cancel" : "Annuleren",
    "delete" : "Verwijderen",
    "aboutToDeleteLink" : "`You bent About om de ${deleteRowName} - Link trigger verwijderen. Deleted Link kan niet worden hersteld, weet You zeker dat You wilt Continue?`",
    "noTriggerLinksFound" : "Geen Trigger Links found",
    "getStartedByAddingNewTriggerLinks" : "Aan de slag Via het toevoegen van new Trigger Links",
    "newTriggerLink" : "LinkNew trigger",
    "searchNoMatch" : "Je Search Link geen trigger opgeleverd.",
    "link" : "Link",
    "addLink" : "Add Link",
    "linkURL" : "Link-URL",
    "name" : "Naam",
    "pleaseEnterNonEmptyLinkName" : "Voer een niet-lege Link in",
    "pleaseEnterURL" : "Voer de URL in",
    "actions" : "activities",
    "linkKey" : "Link Key",
    "keyCopied" : "Key Copied"
  }
}
